import axiosClient from "./AxiosConfig";

const SubscriptionService = {

  async getSubscriptions() {
    const response = await axiosClient.get(`/subscription/get-all`);
    return response.data;
  },

  async createSubscription(subscription) {
    const formData = new FormData();
    if (subscription.imageFile) {
      formData.append("imageFile", subscription.imageFile);
    }
    formData.append(
      "subscription",
      new Blob([JSON.stringify(subscription)], { type: "application/json" })
    );
    const response = await axiosClient.post(`/subscription/create`, formData);
    return response.data;
  },

  async updateSubscription(subscription) {
    const formData = new FormData();
    if (subscription.imageFile) {
      formData.append("imageFile", subscription.imageFile);
    }
    formData.append(
      "subscription",
      new Blob([JSON.stringify(subscription)], { type: "application/json" })
    );
    const response = await axiosClient.patch(`/subscription/update`, formData);
    return response.data;
  },

  async deleteSubscription(id) {
    return await axiosClient.delete(`/subscription/${id}/delete`);
  },

  async updateSubscriptionsOrder(reorderedSubscriptions) {
    const formData = new FormData();
    Array.from(reorderedSubscriptions).forEach((reorderedSubscription) => {
      formData.append(
        "reorderedSubscription",
        new Blob([JSON.stringify(reorderedSubscription)], { type: "application/json" })
      );
    });
    const response = await axiosClient.patch(`/subscription/ordering/update`, formData);
    return response.data;
  }
};

export default SubscriptionService;
